"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _immutable = require("immutable");

var _constants = require("./constants");

var _MarketingFreeSettings = _interopRequireDefault(require("./MarketingFreeSettings"));

var _handleActions;

var initialState = new _MarketingFreeSettings.default({});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchMarketingFreeSettingsActionType.SUCCESS, function (state, action) {
  var newState = new _MarketingFreeSettings.default(action.payload.data);
  return newState.set(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST, (0, _immutable.List)(newState.get(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST)));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateMarketingFreeSettingsActionType.SUCCESS, function (state, action) {
  var newState = new _MarketingFreeSettings.default(action.payload.data);
  return newState.set(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST, (0, _immutable.List)(newState.get(_constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST)));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;